import React, { useState, useEffect, useRef, useMemo } from 'react'

import { actions } from '../../state-actions-reducers'
import { Lang, ScreenProps, Country } from '../../types/common-types'
import { State, Dispatch } from '../../state-actions-reducers'
import TextInput from '../../shared/Inputs/TextInput/TextInput'
import PhoneInput from '../../shared/Inputs/PhoneInput/PhoneInput'
import styles from './ScreenTwo.module.scss'
import warningImage from '../../images/warning.svg'
import SocialLinksInput from '../../shared/Inputs/SocialLinksInput/SocialLinksInput'
import MessengersInput from '../../shared/Inputs/MessengersInput/MessengersInput'
import { checkPhoneEmail } from '../../hooks/useCheckPhoneEmailCustomHook'
import useDebounce from '../../utils/useDebounce'
import OccupationInputs from './OccupationInputs/OccupationInputs'
import AnotherRentalsInputs from '../../shared/Inputs/AnotherRentalsInputs/AnotherRentalsInputs'

interface Props {
  lang: Lang
  state: State
  dispatch: Dispatch
  accountForm: any
  invalidFields: string[]
}
interface Props extends ScreenProps {
  allCitizenships: Country[]
}
/* THE COMPONENT */
function ScreenTwo({
  lang,
  state,
  dispatch,
  accountForm,
  invalidFields,
  allCitizenships,
}: Props) {
  const countriesRef = useRef(
    allCitizenships?.reduce(
      (object, country) => ({
        ...object,
        [country.alpha2 as any]: (country as any)[lang],
      }),
      {}
    )
  )
  const debouncedPhone = useDebounce(state.mobilePhoneNumbers[0], 1500)
  const debouncedMail = useDebounce(state.emails[0], 1500)

  function handleServerError() {
    dispatch({ type: actions.SERVER_ERROR, data: true });
    alert(accountForm.serverError[lang]);
  }

  async function phoneMessage() {
    try {
      let response = await checkPhoneEmail(state, debouncedPhone, debouncedMail)
      if (response.message !== 'Invalid token') {
        dispatch({ type: actions.IS_PHONE_OK, data: response.isPhoneOk })
      } else {
        handleServerError()
      }
    } catch (err) {
      handleServerError()
    }
  }
  async function emailMessage() {
    try {
      let response = await checkPhoneEmail(state, debouncedPhone, debouncedMail)
      if (response.message !== 'Invalid token') {
        dispatch({ type: actions.IS_EMAIL_OK, data: response.isEmailOk })
      } else {
        handleServerError()
      }
    } catch (err) {
      handleServerError()
    }
  }
  useEffect(() => {
    if (debouncedPhone) phoneMessage()
    if (debouncedMail) emailMessage()
  }, [debouncedPhone, debouncedMail])
  
  return (
    <>
      <main className={styles.main}>
        <div className="form-group">
          <div className="row">
            <div className="col-12 col-xs-12">
              <h3>{accountForm.stepTwoContactsTitle[lang]}</h3>
            </div>
          </div>
          <div className='row'>
            <div className="col-4 col-xs-12">
              <PhoneInput
                testName="contactPhoneSeconds"
                testErrorName="error-contactPhoneSeconds"
                label={accountForm.additionalPhoneNumbers.label[lang]}
                lang={lang}
                numbers={
                  state.contactPhoneSeconds.length === 0
                    ? ['']
                    : state.contactPhoneSeconds
                }
                setNumbers={data => {
                  dispatch({
                    type: actions.CONTACT_PHONE_SECOND,
                    data,
                  })
                }}
                valid={!invalidFields.includes('contactPhoneSeconds')}
              />
            </div>
            <div className="col-4 col-xs-12">
              <TextInput
                testName="personalWebsite"
                testErrorName="error-personalWebsite"
                lang={lang}
                content={accountForm.personalWebsite}
                value={state.personalWebsite[0]}
                onChange={data => (
                  dispatch({
                    type: actions.PERSONAL_WEBSITE,
                    data: [data],
                  }),
                  console.log(state.personalWebsite)
                )}
                valid={!invalidFields.includes('personalWebsite')}
              />
            </div>
          </div>
        </div>
        <MessengersInput
          lang={lang}
          state={state}
          invalidFields={invalidFields}
          dispatch={dispatch}
          allCitizenships={allCitizenships}
          phoneNumbers={state.mobilePhoneNumbers}
        />
        <SocialLinksInput
          lang={lang}
          state={state}
          dispatch={dispatch}
          accountForm={accountForm}
          invalidFields={invalidFields}
        />
        <OccupationInputs
          lang={lang}
          state={state}
          dispatch={dispatch}
          accountForm={accountForm}
          invalidFields={invalidFields}
        />
        <AnotherRentalsInputs 
          lang={lang}
          state={state}
          dispatch={dispatch}
          accountForm={accountForm}
          invalidFields={invalidFields}
        />
        <div className="form-group">
          <div className="row">
            <div className="col-12 col-xs-12">
              <h3>{accountForm.stepTwoRecomendation[lang]}</h3>
            </div>
            <div className="col-6 col-xs-12">
              <TextInput
                testName="recommendations"
                testErrorName="error-recommendations"
                lang={lang}
                content={accountForm.recommendations}
                value={state.recommendations}
                onChange={data =>
                  dispatch({
                    type: actions.RECOMMENDATIONS,
                    data,
                  })
                }
                valid={!invalidFields.includes('recommendations')}
                required
              />
            </div>
            <div className="col-12 col-xs-12">
              <p className={styles.warningMessage}>
                <img src={warningImage} alt="warningImage"></img>
                {accountForm.stepRecomendationWarning[lang]}
              </p>
            </div>
          </div>
        </div>
      </main>
    </>
  )
}

export default ScreenTwo
